import React from "react";
import { useTranslation } from "react-i18next";
import { cloneDeep } from "lodash";
import Input from "components/form/input/Input";
import Toggle from "components/form/toggle/Toggle";
import { useFormBuilderEditorContext } from "../../../formBuilderEditorContext";
import { useFormBuilderDebouncedUpdate } from "../../../hooks/debouncedUpdate/useFormBuilderDebouncedUpdate";
import { TFormBuilderFormSettings } from "../../../model/formBuilderForm";
import { FormBuilderPanelDivider } from "../../FormBuilderPanelDivider";
import "./formBuilderFormSettings.scss";

export function FormBuilderFormSettings() {
  const { t } = useTranslation();

  const { formBuilderController } = useFormBuilderEditorContext();

  const settings = formBuilderController.form.settings;

  const debouncedName = useFormBuilderDebouncedUpdate<string>({
    defaultValue: "",
    value: settings.name,
  });

  function dispatchSettings(partialNextSettings: Partial<TFormBuilderFormSettings>) {
    formBuilderController.updateFormSettings({
      prevFormSettings: cloneDeep(settings),
      nextFormSettings: {
        ...cloneDeep(settings),
        ...partialNextSettings,
      },
    });
  }

  return (
    <div className="form-builder-form-settings">
      <div className="form-settings-section">
        <Input
          label={t("Form name")}
          value={debouncedName.state.active ? debouncedName.state.value : settings.name}
          onFocus={debouncedName.activate}
          onChange={e => {
            debouncedName.change(e.target.value, name => {
              dispatchSettings({ name });
            });
          }}
          onBlur={() =>
            debouncedName.commit(name => {
              dispatchSettings({ name });
            })
          }
        />
      </div>

      <FormBuilderPanelDivider />

      <div className="form-settings-section">
        <h3 className="form-settings-section-heading">{t("Notifications")}</h3>

        <div className="form-settings-toggle-container">
          <Toggle
            checked={settings.emailNotificationsEnabled}
            onChange={e => {
              dispatchSettings({
                emailNotificationsEnabled: e.target.checked,
              });
            }}
          />

          <div className="form-settings-toggle-info">
            <div className="form-settings-toggle-label">{t("Email notifications")}</div>
            <div className="form-settings-toggle-description">
              {t("Enable email alerts for your facility on each submission.")}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
